<template lang="pug">
    .component-subscription-smart-edit
        smart-edit(:options="options", :value="item", @input="updateFields")
        button.button.expanded(v-on:click="edit") Save and Submit
</template>
<script type="text/babel">
    import SmartEdit from "components/structure/SmartEdit"
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import MaggieHelper from "src/maggieHelper";

    export default{
        name: "SubscriptionSmartEdit",
        components: {SmartEdit},
        data(){
            return {
                options: {
                    translations: {},
                    types: {
                        start: 'date',
                        end: 'date',
                        next_due_date: 'date',
                        auto_renew: ['0','1'],
                    },
                    disabled: [
                        "id",
                    ],
                    list: [

                        "uid",
                        "client",
                        "plan",
                        "drivers"
                    ],
                    listMode: 'blacklist',
                }
            }
        },
        created() {
        },
        methods: {
            updateFields(item){
                this.item = item
            },
            edit(){
                KeplerBackofficeSdk.subscriptions.select(this.item.id).edit(this.item, (data) => {
                    MaggieHelper.notification('edit-esit', 'Subscription edited');

                    location.reload()
                })
            }
        },
        props: [
            'item'
        ]
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// SubscriptionEdit.vue?10971ec5